/*
 * @Author: Teemo Ding
 * @Date: 2021-07-07 16:45:59
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 14:56:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Order/UnpaidOrderCancellation/index.tsx
 */
import { Label, NumberInput, Select } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { calc2Minute } from '@/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Template/tools';
import { Icon } from '@/src/tools/icon';
import { RemindUnitProps } from '@/src/types/common';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

type PaymentReminder = {
  [key: string]: number;
};

const UnpaidOrderCancellation = ({
  disabled,
  listPaymentReminders,
}: {
  disabled?: boolean;
  listPaymentReminders: PaymentReminder[];
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const optionsList = [
    { value: 'Hours', label: getI18n('storeOrderSetting.detail.hours') },
    {
      value: 'RollingDays',
      label: getI18n('storeOrderSetting.detail.rollings'),
    },
  ];
  const minimumPaymentReminder: number = (listPaymentReminders || []).reduce(
    (p, c) => {
      const v = Math.min.apply(null, Object.values(c));
      return v < p ? v : p;
    },
    Infinity,
  );

  return (
    <SectionWrapper
      titleClassName={css.titleContainerAll}
      title={getI18n('storeOrderSetting.detail.unpaidOrderCancellation')}
      className={css.storeDetailsInfo}>
      <Form.Item
        labelCol={{
          span: 24,
        }}
        className={css.unpaidOrderForm}
        label={
          <Label
            title={getI18n(
              'storeOrderSetting.detail.unpaidOrderCancellationTime',
            )}
            bottomTitle={getI18n('storeOrderSetting.detail.unpaidTip')}
          />
        }>
        <div className={css.unpaidOrder}>
          <Form.Item dependencies={['timeUnit']}>
            {({ getFieldValue, validateFields }) => {
              const timeUnit = getFieldValue('timeUnit');
              validateFields(['cancellationTime']);

              return (
                <Form.Item
                  name='cancellationTime'
                  className={css.timeInput}
                  rules={[
                    {
                      validator: async (_, value) => {
                        const unit =
                          timeUnit === 'Hours'
                            ? RemindUnitProps.Hours
                            : RemindUnitProps.Days;

                        const minutesTime = calc2Minute(Number(value), unit);

                        if (
                          minimumPaymentReminder !== Infinity &&
                          minutesTime < minimumPaymentReminder
                        ) {
                          return Promise.reject(
                            getI18n('storeOrderSetting.detail.unpaidTip2'),
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}>
                  <NumberInput
                    max={2000000000}
                    size='large'
                    disabled={disabled}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item name='timeUnit'>
            <Select
              className={css.unpaidOrderSelect}
              suffixIcon={<Icon type='icondown' className={css.icon} />}
              size='large'
              optionsList={optionsList}
              disabled={disabled}
            />
          </Form.Item>
          <span className={css.unpaidOrderSelectSpan}>
            {getI18n('storeOrderSetting.detail.afterorderplaced')}
          </span>{' '}
        </div>
      </Form.Item>
    </SectionWrapper>
  );
};

export default UnpaidOrderCancellation;
